import { FeatureFlag } from '@/types/featureFlag';
import { useFeatureFlagEnabledQuery } from '@/utils/useFeatureFlagEnabled';

import { isReassignableVisit } from './v3/isReassignableVisit';

// Whether the user can complete a v3 reassign of a visit.
// The v3 flow submits status=unscheduled + outcome=none + the clinician through `/visit/edit`,
// so the backend requires assign + editState + editOutcome.
export const canReassignVisitV3 = isReassignableVisit;

// Legacy reassign goes through the route-optimizer `finalizeRoutes` mutation, gated by the
// org-level `ROUTE_OPTIMIZER_EDIT`, not a per-visit permission.

// The reassignability check for the active reassign flow, or `null` for legacy. The v2 flag now
// routes to the v3 flow, so it uses the same check.
export const useReassignVisitPermissionsFilter = () => {
    const { enabled: hasV3 } = useFeatureFlagEnabledQuery(
        FeatureFlag.DASHBOARD_VISIT_REASSIGNMENT_FLOW,
    );
    const { enabled: hasV2 } = useFeatureFlagEnabledQuery(FeatureFlag.REASSIGN_VISITS_FLOW_V2);

    if (hasV3 || hasV2) {
        return canReassignVisitV3;
    }
    return null;
};
